import { defineMessages } from 'react-intl-next';

export default defineMessages({
	modalTitle: {
		id: 'rovo-chat.browse-agents.modal-title',
		defaultMessage: 'Browse agents',
		description: 'Title of the modal to browse agents',
	},
	allAgentsButton: {
		id: 'rovo-chat.browse-agents.all-agents-button',
		defaultMessage: 'All',
		description: 'Button to show all agents',
	},
	starredAgentsButton: {
		id: 'rovo-chat.browse-agents.starred-agents-button',
		defaultMessage: 'Starred',
		description: 'Button to show starred agents',
	},
	myAgentsButton: {
		id: 'rovo-chat.browse-agents.my-agents-button',
		defaultMessage: 'My agents',
		description: 'Button to show agents created by the user',
	},
	createAgentButton: {
		id: 'rovo-chat.browse-agents.create-agent-button',
		defaultMessage: 'Create',
		description: 'Button to create a new agent, shown in the header',
	},
	createAnAgentButton: {
		id: 'rovo-chat.browse-agents.create-an-agent-button',
		defaultMessage: 'Create an agent',
		description:
			'Button to create a new agent, shown on the empty view when no agentsn are available yet',
	},
	closeButton: {
		id: 'rovo-chat.browse-agents.close-button',
		defaultMessage: 'Close',
		description: 'Button to close the modal',
	},
	searchPlaceholder: {
		id: 'rovo-chat.browse-agents.search-input.placeholder',
		defaultMessage: 'Search agents',
		description: 'Placeholder for the chat view search input',
	},
	createdByLabel: {
		id: 'rovo-chat.browse-agents.created-by-label',
		defaultMessage: `<text>by</text> {creatorName}`,
		description: 'Label to indicate the creator of the agent',
	},
	viewAgent: {
		id: 'rovo-chat.browse-agents.view-agent',
		defaultMessage: 'View agent',
		description: 'Button to view an agent',
	},
	duplicateAgent: {
		id: 'rovo-chat.browse-agents.duplicate-agent',
		defaultMessage: 'Duplicate agent',
		description: 'Button to duplicate an agent',
	},
	editAgent: {
		id: 'rovo-chat.browse-agents.edit-agent',
		defaultMessage: 'Edit agent',
		description: 'Button to edit an agent',
	},
	deleteAgent: {
		id: 'rovo-chat.browse-agents.delete-agent',
		defaultMessage: 'Delete agent',
		description: 'Button to delete an agent',
	},
	copyLinkToProfile: {
		id: 'rovo-chat.browse-agents.copy-link-to-profile',
		defaultMessage: 'Copy link',
		description: 'Button to copy the link to the agent profile',
	},
	linkedCopiedToProfile: {
		id: 'rovo-chat.browse-agents.link-copied-to-profile',
		defaultMessage: 'Copied URL',
		description: 'Button confirming link to agent profile is copied',
	},
	learnMore: {
		id: 'rovo-chat.browse-agents.learn-more',
		defaultMessage: 'Learn more',
		description: 'Link to learn more about created agents',
	},
	noCreatedAgentsHeader: {
		id: 'rovo-chat.browse-agents.no-created-agents-header',
		defaultMessage: 'No agents created yet',
		description: 'Header to display when there are no created agents',
	},
	noCreatedAgents: {
		id: 'rovo-chat.browse-agents.no-created-agents',
		defaultMessage:
			"It looks like you haven't created any agents yet. Start by duplicating other existing agents or begin from scratch to create one.",
		description: 'Message to display when there are no created agents',
	},
	favouritedAgentLabel: {
		id: 'rovo-chat.browse-agents.favourited-agent-label',
		defaultMessage: 'Favourited agent',
		description: 'Favourited agent label',
	},
	moreActionsLabel: {
		id: 'rovo-chat.browse-agents.more-actions-label',
		defaultMessage: 'More actions',
		description: 'More actions dropdown menu label',
	},
	noResults: {
		id: 'rovo-chat.browse-agents.no-results',
		defaultMessage: 'No results',
		description: 'Message to display when there are no search results',
	},
});
